module.exports = __webpack_public_path__ + "static/media/vapour.3bca0791.png";